<div class="dialog-content duo-action-dialog">
  <!--title 標題-->
  @if (data.title) {
    <h1 class="dialog-title">{{ data.title }}</h1>
  }
  <!--btn:關閉按鈕-->
  @if (data.showCloseButton) {
    <button mat-button (click)="close()" class="dialog-close-btn">
      <img src="assets/img/i-close.svg" alt="" />
    </button>
  }
  <!--dialog 內容-->
  @if (data.message) {
    <div mat-dialog-content>
      <p class="duo-action-dialog-body" [innerHTML]="data.message"></p>
    </div>
  }
  <div class="dialog-btn-block">
    <button
      mat-button
      class="btn-outline-primary btn-size-l"
      (click)="onLeftButtonClick()">
      {{ data.leftButtonText }}
    </button>
    <button
      mat-button
      class="btn-fill-primary btn-size-l"
      (click)="onRightButtonClick()">
      {{ data.rightButtonText }}
    </button>
  </div>
</div>